import React from "react";

import Table from "./Table/";
import Header from "./Header/";
import Footer from "./Footer/";

import Paper from "@material-ui/core/Paper";

import paginate from "jw-paginate";

import { sortComparator, sortArray } from "utils/sort-array";

import { debounce } from "lodash";

import "./style.scss";

export default class extends React.Component {
  rowsPerPageOptions = [5, 10, 25, 50, 100, 200, 300, 400, 500, 1000];

  state = {
    count: 0,
    page: this.props.page || 0,
    rowsPerPage: this.props.rowsPerPage || 500,
    data: this.props.data || [],
    columns: this.props.columns || [],
    order: this.props.order || "asc",
    orderBy: this.props.orderBy || null,
    numSelected: 0,
    selected: this.props.selected || [],
    isLoading: false,
    searchText: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      count: this.state.data.length,
      numSelected: this.state.selected.length,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { data } = this.props;

    if (data === prevProps.data) {
      return;
    }

    this.setState({
      data,
    });
  }

  data() {
    let { data, searchText, count } = this.state;
    const { columns, page, rowsPerPage, order, orderBy } = this.state;

    if (this.hasSearch() && searchText) {
      searchText = searchText.toLowerCase();

      data = data.reduce((agg, item) => {
        let hasSearchText = false;

        Object.keys(item).forEach((key) => {
          let value = item[key];
          const column = columns[key];

          if (column) {
            if (column.values) {
              value = column.values[value] ? column.values[value].name : null;
            }
          }

          if (!value) {
            return;
          }

          if (typeof value === "number") {
            if (value === parseInt(searchText)) {
              hasSearchText = true;
            }
          } else if (typeof value === "string") {
            if (value.toLowerCase().includes(searchText)) {
              hasSearchText = true;
            }
          }
        });

        if (hasSearchText) {
          return [...agg, item];
        }

        return agg;
      }, []);

      count = data.length;
    }

    if (this.hasPagination() && rowsPerPage > 0) {
      const pagination = paginate(count, page + 1, rowsPerPage);

      if (count > rowsPerPage) {
        if (this.hasSort() && order && orderBy) {
          return {
            data: sortArray(data, sortComparator(order, orderBy)).slice(
              pagination.startIndex,
              pagination.endIndex + 1
            ),
            count,
          };
        }

        return {
          data: data.slice(pagination.startIndex, pagination.endIndex + 1),
          count,
        };
      }
    }

    if (this.hasSort()) {
      return { data: sortArray(data, sortComparator(order, orderBy)), count };
    }

    if (data.length > rowsPerPage) {
      const pagination = paginate(count, 1, rowsPerPage);

      return {
        data: data.slice(pagination.startIndex, pagination.endIndex + 1),
        count,
      };
    }

    return {
      data,
      count,
    };
  }

  hasPagination() {
    return this.props.hasPagination || false;
  }

  hasSelection() {
    return this.props.hasSelection || false;
  }

  hasSort() {
    return this.props.hasSort || false;
  }

  hasAdd() {
    return this.props.hasAdd || false;
  }

  hasSearch() {
    return this.props.hasSearch || true;
  }

  onSelectAll() {
    if (this.hasSelection()) {
      let { selected } = this.state;
      const { numSelected } = this.state;
      const { data } = this.data();

      if (numSelected > 0) {
        selected = [];
      } else {
        selected = data.map((item) => item.id);
      }

      this.setState({
        ...this.state,
        selected,
        numSelected: selected.length,
      });

      const onSelect = this.props.onSelect || null;
      if (onSelect) {
        return onSelect(selected);
      }
    }
  }

  async onSelection(row) {
    const { hasMultipleSelection } = this.props;

    const { id } = row;

    if (this.hasSelection() && id) {
      const onSelected = this.props.onSelected || null;
      if (onSelected) {
        const result = await onSelected(row);
        if (!result) {
          return false;
        }
      }

      let { selected } = this.state;
      const isItemSelected = selected.includes(id);

      if (isItemSelected) {
        selected = selected.filter((item) => item !== id);
      } else {
        if (hasMultipleSelection) {
          selected = [...this.state.selected, id];
        } else {
          selected = [id];
        }
      }

      this.setState({
        ...this.state,
        selected,
        numSelected: selected.length,
      });

      const onSelect = this.props.onSelect || null;
      if (onSelect) {
        onSelect(selected);
      }
    }

    return true;
  }

  onSelectionConfirm() {
    if (this.hasSelection()) {
      const onSelectionConfirm = this.props.onSelectionConfirm || null;
      const { selected, data } = this.state;

      if (onSelectionConfirm) {
        onSelectionConfirm(selected, data);
      }
    }
  }

  onSelectionDelete() {
    if (this.hasSelection()) {
      window.confirm("Are you sure bruh?");
    }
  }

  async onAdd(row) {
    this.setState({
      ...this.state,
      isLoading: true,
    });

    let { data } = this.state;

    const onAdd = this.props.onAdd || null;
    if (onAdd) {
      const result = await onAdd(row);
      if (result) {
        data.push({ ...row, ...result });
      } else {
        this.setState({
          ...this.state,
          isLoading: false,
        });

        return false;
      }
    } else {
      data.push(row);
    }

    this.setState({
      ...this.state,
      data,
      count: data.length,
      isLoading: false,
    });

    return true;
  }

  async onEditChange(updated) {
    this.setState({
      isLoading: true,
    });

    const data = this.state.data.map((item) =>
      item.id === updated.id ? { ...item, ...updated } : item
    );

    this.setState({
      isLoading: false,
      data,
    });
  }

  async onEdit(row) {
    this.setState({
      ...this.state,
      isLoading: true,
    });

    let { data } = this.state;

    const onEdit = this.props.onEdit || null;
    if (onEdit) {
      const result = await onEdit(row);
      if (result) {
        data = data.map((item) =>
          item.id === row.id ? { ...row, ...result } : item
        );
      } else {
        this.setState({
          ...this.state,
          isLoading: false,
        });

        return false;
      }
    } else {
      data = data.map((item) => (item.id === row.id ? row : item));
    }

    this.setState({
      ...this.state,
      data,
      isLoading: false,
    });

    return true;
  }

  async onDelete(row) {
    this.setState({
      ...this.state,
      isLoading: true,
    });

    let { data, selected } = this.state;

    const onDelete = this.props.onDelete || null;
    if (onDelete) {
      const result = await onDelete(row);
      if (result) {
      } else {
        this.setState({
          ...this.state,
          isLoading: false,
        });

        return false;
      }
    }

    data = data.reduce(
      (agg, item) => (item.id === row.id ? agg : [...agg, item]),
      []
    );

    selected = selected.reduce(
      (agg, item) => (item === row.id ? agg : [...agg, item]),
      []
    );

    this.setState({
      ...this.state,
      data,
      selected,
      numSelected: selected.count,
      count: data.length,
      isLoading: false,
    });

    return true;
  }

  onChangePage(state) {
    if (this.hasPagination()) {
      this.setState({ ...this.state, ...state });
    }
  }

  onChangeRowsPerPage(state) {
    if (this.hasPagination()) {
      this.setState({ ...this.state, ...state });
    }
  }

  onSortChange(state) {
    if (this.hasSort()) {
      this.setState({
        ...this.state,
        ...state,
      });
    }
  }

  onSearchChange(searchText) {
    this.setState({ ...this.state, searchText });
  }

  render() {
    const { isLoading } = this.state;

    const { data, count } = this.data();

    const { rowsPerPageOptions } = this;
    const combined = {
      ...this.props,
      ...this.state,
      data,
      rowsPerPageOptions,
      count,
    };

    const HeaderComponent = this.props.headerComponent || null;

    return (
      <div className="zee-table">
        {isLoading && (
          <div className="loading">
            <div className="loader"></div>
          </div>
        )}

        <Header
          {...combined}
          onSearchChange={debounce(
            (searchText) => this.onSearchChange(searchText),
            500
          )}
        />

        {HeaderComponent && <HeaderComponent {...this.props} />}

        <Table
          {...combined}
          onSelectAll={() => this.onSelectAll()}
          onSelection={(row) => this.onSelection(row)}
          onSortChange={(orderBy, order) => this.onSortChange(orderBy, order)}
          onEdit={(row) => this.onEdit(row)}
          onDelete={(row) => this.onDelete(row)}
          onAdd={(row) => this.onAdd(row)}
          onEditChange={(row) => this.onEditChange(row)}
        />

        <Footer
          {...combined}
          onChangePage={(state) => this.onChangePage(state)}
          onChangeRowsPerPage={(state) => this.onChangeRowsPerPage(state)}
          onSelectionConfirm={() => this.onSelectionConfirm()}
          onSelectionDelete={() => this.onSelectionDelete()}
        />
      </div>
    );
  }
}
